import { render, staticRenderFns } from "./PaymentVa.vue?vue&type=template&id=1ff4d2ee"
import script from "./PaymentVa.vue?vue&type=script&lang=js"
export * from "./PaymentVa.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./PaymentVa.vue?vue&type=style&index=0&id=1ff4d2ee&prod&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports